"use client";
import { Box, Stack, Flex, Separator } from "@chakra-ui/react";
import Link from "next/link";
import Image from "next/image";
import { useHeadingVariant, useTextVariant } from "@/theme/hooks/useSectionStyle";
import { Heading, Text, Button } from "@/elements";
import DottedBgImage from "public/shared/dotted-background-image.png";
import VideoPlayerWithOverlay from "./videoPlayer";

type Props = {
  LeftPanel: {
    title: string;
    button: {
      text: string;
      link: string;
      label: string;
    };
  };
  RightPanel: {
    list: {
      title: string;
      content: string;
    }[];
  };
};

const VideoFrame = (props: Props) => {
  const HeadingVariant = useHeadingVariant();
  const TextVariant = useTextVariant();
  const { LeftPanel, RightPanel } = props;
  return (
    <Flex direction={{ base: "column", md: "row" }}>
      <Box position="relative" flex={"0 0 60%"} borderRadius={"8px"}>
        <Image
          src={DottedBgImage}
          alt=""
          fill
          style={{
            objectFit: "cover",
            zIndex: -1,
            borderRadius: "8px",
          }}
          priority={false}
        />
        <Stack
          gap={10}
          width={{ base: "100%", md: "85%" }}
          py={{ base: 10, md: 20 }}
          px={{ base: 6, md: 20 }}
          align={{ base: "center", md: "flex-start" }}
        >
          <Heading as="h2" variant={HeadingVariant} color="white">
            {LeftPanel.title}
          </Heading>
          <VideoPlayerWithOverlay />
          <Stack gap={2}>
            <Text variant={TextVariant} color="white">
              {LeftPanel.button.text}
            </Text>
            <Button
              as={Link}
              mb={{ base: 2, md: 0 }}
              variant={"secondary"}
              href={LeftPanel.button.link}
              width={"fit-content"}
            >
              {LeftPanel.button.label}
            </Button>
          </Stack>
        </Stack>
      </Box>
      <Box
        my={{ base: "-4vw", md: "2vw" }}
        mx={{ base: "5vw", md: "5vw" }}
        ml={{ md: "-10%" }}
        backgroundColor={"white"}
        flex={"0 0 50%"}
        borderRadius={"8px"}
        justifyContent={"space-around"}
        boxShadow={"xl"}
        p={{ base: 5, md: 10 }}
      >
        {RightPanel.list.map((item, index) => (
          <Box key={index}>
            <Box>
              <Heading variant={"subTitle3"} as="span" color="primary.200">
                {item.title}
              </Heading>{" "}
              :{" "}
              <Text variant={"body2"} as="span" color="text.100">
                {item.content}
              </Text>
            </Box>

            <Separator my={4} />
          </Box>
        ))}
      </Box>
    </Flex>
  );
};

export default VideoFrame;
